import { selectMirrorVideo } from 'features/streaming/streamingSlice';
import { select } from 'redux-saga/effects';
import { safeLocalStorage } from 'utils/storage';

export function* toggleMirrorVideoSaga() {
  const mirrorVideo: boolean = yield select(selectMirrorVideo);

  safeLocalStorage.setItem(`mirror_video`, `${mirrorVideo}`);
}
